import styled from 'styled-components';
import { Dialog } from '@material-ui/core';

export const DialogBody = styled.div`
    display: grid;
    grid-auto-flow: row;
    gap: 1rem;
    width: 100%;
    overflow-y: auto;
    padding: 24px;
`;

export const DialogTitle = styled.div`
    font-size: 20px;
    font-weight: 600;
    align-items: center;
`;

export const DialogStyled = styled(Dialog)`
    [role='dialog'] {
        min-width: 400px;
        max-width: max-content;
        overflow: visible;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

export const DialogAction = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-top: 1px solid #e0e0e0;
    padding: 16px;
    button {
        margin-left: 12px;
    }
`;

export const DialogHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-height: 60px;
    width: 100%;
    border-bottom: 1px solid #e0e0e0;
    padding: 0px 12px 0px 24px;
`;

export const DialogHeaderAction = styled.div`
    display: flex;
    flex-direction: row;
    button:last-child {
        margin-left: 8px;
    }
`;
